export default "__VITE_ASSET__DedBeqOC__"